import React from 'react';
import { FormAsyncSelect, FormMultiSelect, FormSelect } from 'shared/formControls';
import cm from './LocationsDropdown.module.scss';
import { useGetLocations } from 'src/fetch/locations';
import { emptyArray } from 'src/shared/helpers/utils';

const LocationsDropdown = ({
  multiSelect,
  showAddress = true,
  value,
  minimal,
  enableGoTo = true,
  getData,
  ...others
}) => {
  const { data: locations = emptyArray } = useGetLocations();
  const SelectComponent = getData ? FormAsyncSelect : (multiSelect ? FormMultiSelect : FormSelect);
  const val = typeof value === 'object' ? value : locations.find((x) => x.id == value) ?? null;

  const goesToLink = () => {
    const v = val?.value != null || val != null
      ? `/organizations/locations/${val?.id != null ? val?.id : val}`
      : null;
    return v;
  };
  const renderAddressOption = (li, itemProps) => {
    const address = itemProps?.dataItem?.fullDisplayAddress || '';
    const itemChildren = (
      <span
        className={cm.item}
      >
        <div
          style={{
            flexBasis: '100%',
          }}
        >
          {li.props.children}
        </div>
        {
          address && (
            <div
              className={cm.address}
            >
              {`${address}`}
            </div>
          )
        }
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const renderAddressValue = (element) => {
    if (element?.key === 'searchbar') {
      return element;
    }

    if (!element?.props?.value) {
      return element;
    }

    const item = locations.find((x) => x.name === element.props.value);
    const address = item?.fullDisplayAddress || '';

    return (
      <span
        className={cm.value}
      >
        <div
          style={{
            flexShrink: 0,
            marginRight: 8,
          }}
        >
          {item?.name}
        </div>
        {
          address && (
            <div
              className={cm.valueAddress}
            >
              {` ${address}`}
            </div>
          )
        }
      </span>
    );
  };

  return (
    <SelectComponent
      getData={getData || undefined}
      data={locations}
      textField='name'
      dataItemKey='id'
      itemRender={showAddress ? renderAddressOption : undefined}
      valueRender={showAddress ? renderAddressValue : undefined}
      multiSelect={multiSelect}
      minimal={minimal}
      {...others}
      goesTo={minimal || !enableGoTo ? '' : goesToLink()}
      value={val ?? ''}
    />
  );
};

export default LocationsDropdown;